import { Pipe, PipeTransform } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppFacade } from '@app/app.facade';
import { Place } from '@app/entities/place';

@Pipe({
  name: 'deeplinkPlace',
  standalone: false
})
export class DeeplinkPlacePipe implements PipeTransform {

  constructor(private facade: AppFacade) { }

  transform(code: string): Observable<Place> {
    return zip(
      this.facade.airportsEntities$,
      this.facade.placesEntities$
    ).pipe(map(([airports, places]) => {
      if (places?.[code]) {
        const name = places[code].name.substring(0, places[code].name.indexOf(','));
        return { ...places[code], name };
      } else if (airports?.[code]) {
        return {
          ...airports[code],
          id: airports[code].code,
          cityCode: airports[code].code,
          country: airports[code].country,
          is_airport: true
        };
      } else {
        return code ? {
          id: code,
          name: code,
          country: code,
          city: code,
          cityCode: code,
        } as Place : {} as Place;
      }
    }));
  }
}
